// Ported from de-payment-admin (src/components/settings/use-bank-consent.ts).
// Opens the bank consent popup and resolves once it posts BANK_AUTH_DONE or closes.
//
// NOTE: the Golomt consent redirect_uri is configured on the payment side, so the
// popup may land on the payment app's /bank-callback (a different origin) — its
// postMessage would then be cross-origin and dropped by the origin check. The
// popup-close detection below is the reliable completion signal in that case; the
// caller then confirms the account via the list endpoint.
export function openBankConsent(url: string, windowName: string): Promise<void> {
  const win = window.open(url, windowName, "height=800,width=700");
  return new Promise<void>((resolve) => {
    const cleanup = () => {
      window.removeEventListener("message", onMessage);
      clearInterval(timer);
    };
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === "BANK_AUTH_DONE") {
        cleanup();
        try { win?.close(); } catch { /* ignore */ }
        resolve();
      }
    };
    const timer = setInterval(() => {
      if (!win || win.closed) {
        cleanup();
        resolve();
      }
    }, 500);
    window.addEventListener("message", onMessage);
  });
}
